// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@imgs/register/purple-theme/logo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("@imgs/register/new-theme/bottom-body-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("@imgs/activity/check.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes skin12_rotate__hHuvF {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.skin12_skin12__\\+oCbv {
  height: 100%;
  background-color: #f5f6f9;
  line-height: normal;
}
.skin12_skin12__\\+oCbv .skin12_header__Pbeb9 {
  padding: 5.333333vw 4.266667vw 2.666667vw;
  width: 100%;
  background-repeat: no-repeat;
  background-size: 100% 58.666667vw;
  background-image: linear-gradient(1turn, #DDDDFA, #7D7DFD);
}
.skin12_skin12__\\+oCbv .skin12_header__Pbeb9 .skin12_logoBox__CGCWS {
  display: flex;
  align-items: center;
  font-size: 5.333333vw;
  font-weight: 600;
  line-height: 5.333333vw;
}
.skin12_skin12__\\+oCbv .skin12_header__Pbeb9 .skin12_logoBox__CGCWS .skin12_logo__F142n {
  margin-right: 2.666667vw;
  width: 11.2vw;
  height: 11.2vw;
  background-size: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.skin12_skin12__\\+oCbv .skin12_header__Pbeb9 .skin12_logoBox__CGCWS .skin12_logoBoxRight__N21O0 {
  display: flex;
  flex-direction: column;
}
.skin12_skin12__\\+oCbv .skin12_header__Pbeb9 .skin12_logoBox__CGCWS .skin12_logoBoxRight__N21O0 .skin12_logoText__XfZyb {
  width: 21.333333vw;
  height: 5.6vw;
}
.skin12_skin12__\\+oCbv .skin12_header__Pbeb9 .skin12_logoBox__CGCWS .skin12_logoBoxRight__N21O0 .skin12_youqianLogoText__P4Av- {
  height: 5.6vw;
}
.skin12_skin12__\\+oCbv .skin12_header__Pbeb9 .skin12_logoBox__CGCWS .skin12_logoBoxRight__N21O0 .skin12_youqianLogoText__P4Av- {
  height: 5.6vw;
}
.skin12_skin12__\\+oCbv .skin12_header__Pbeb9 .skin12_logoBox__CGCWS .skin12_logoBoxRight__N21O0 .skin12_logoText2__pZmv1 {
  margin-top: 1.066667vw;
  width: 20.266667vw;
  height: 2.666667vw;
}
.skin12_skin12__\\+oCbv .skin12_header__Pbeb9 .skin12_logoBox__CGCWS .skin12_logoBoxRight__N21O0 .skin12_logoText3__wrliU {
  margin-top: 1px;
  font-size: 3.2vw;
  font-weight: 600;
  color: #ffffff;
  transform: scale(0.86) translateX(-2.666667vw);
}
.skin12_skin12__\\+oCbv .skin12_header__Pbeb9 .skin12_inputWrapper__Dc2pO {
  margin-top: 6.666667vw;
  border-radius: 2.133333vw;
  width: 91.466667vw;
  background: linear-gradient(180deg, #fbe5d7 0%, #ffffff 27.54%);
}
.skin12_skin12__\\+oCbv .skin12_header__Pbeb9 .skin12_inputWrapper__Dc2pO .skin12_inputWrapperHead__gXHjk {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 7.733333vw;
  width: 100%;
  height: 13.333333vw;
}
.skin12_skin12__\\+oCbv .skin12_header__Pbeb9 .skin12_inputWrapper__Dc2pO .skin12_inputWrapperContainer__C9gdU {
  margin-top: 3.2vw;
  padding: 6.4vw 3.2vw 4.266667vw;
}
.skin12_skin12__\\+oCbv .skin12_header__Pbeb9 .skin12_inputWrapper__Dc2pO .skin12_inputWrapperContainer__C9gdU .skin12_inputWrapperContainetTips__\\+7UHi {
  margin-bottom: 2.133333vw;
  font-size: 3.733333vw;
  color: #262626;
}
.skin12_skin12__\\+oCbv .skin12_header__Pbeb9 .skin12_inputWrapper__Dc2pO .skin12_inputWrapperContainer__C9gdU .skin12_inputBox__VtveO {
  position: relative;
  display: flex;
  align-items: center;
}
.skin12_skin12__\\+oCbv .skin12_header__Pbeb9 .skin12_inputWrapper__Dc2pO .skin12_inputWrapperContainer__C9gdU .skin12_inputBox__VtveO .skin12_inputBoxSymbol__uSjT1 {
  font-size: 10.133333vw;
  line-height: 13.866667vw;
}
.skin12_skin12__\\+oCbv .skin12_header__Pbeb9 .skin12_inputWrapper__Dc2pO .skin12_inputWrapperContainer__C9gdU .skin12_inputBox__VtveO .adm-input-element {
  font-size: 8.8vw;
  font-weight: 600;
  line-height: 8vw;
}
.skin12_skin12__\\+oCbv .skin12_header__Pbeb9 .skin12_inputWrapper__Dc2pO .skin12_inputWrapperContainer__C9gdU .skin12_inputBox__VtveO .adm-input-element::placeholder {
  font-size: 5.866667vw;
  line-height: 8vw;
  font-weight: normal;
}
.skin12_skin12__\\+oCbv .skin12_header__Pbeb9 .skin12_inputWrapper__Dc2pO .skin12_inputWrapperContainer__C9gdU .skin12_inputBox__VtveO .skin12_text__bkLpf {
  position: absolute;
  right: 0;
  bottom: 3.733333vw;
  display: flex;
  align-items: center;
  font-size: 3.2vw;
  color: #de9960;
}
.skin12_skin12__\\+oCbv .skin12_header__Pbeb9 .skin12_inputWrapper__Dc2pO .skin12_inputWrapperContainer__C9gdU .skin12_inputBox__VtveO .skin12_text__bkLpf .skin12_clear__0NJ-r {
  padding-left: 2.4vw;
  font-size: 4.266667vw;
  color: #8c8c8c;
}
.skin12_skin12__\\+oCbv .skin12_header__Pbeb9 .skin12_inputWrapper__Dc2pO .skin12_inputWrapperContainer__C9gdU .skin12_moneyOptions__IvfZm {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2.666667vw;
}
.skin12_skin12__\\+oCbv .skin12_header__Pbeb9 .skin12_inputWrapper__Dc2pO .skin12_inputWrapperContainer__C9gdU .skin12_moneyOptions__IvfZm .skin12_moneyItem__ZGgVb {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 1.6vw;
  padding: 1.066667vw 2.133333vw;
  height: 8.533333vw;
  font-size: 3.733333vw;
  font-weight: 600;
  color: #8c8c8c;
  background-color: #f3f4f6;
  flex: 1 1;
  box-sizing: border-box;
  line-height: normal;
}
.skin12_skin12__\\+oCbv .skin12_header__Pbeb9 .skin12_inputWrapper__Dc2pO .skin12_inputWrapperContainer__C9gdU .skin12_moneyOptions__IvfZm .skin12_moneyItem__ZGgVb:nth-child(2n+2) {
  margin: 0 2.133333vw;
}
.skin12_skin12__\\+oCbv .skin12_header__Pbeb9 .skin12_inputWrapper__Dc2pO .skin12_inputWrapperContainer__C9gdU .skin12_moneyOptions__IvfZm .skin12_moneyItem__ZGgVb.skin12_moneyItemActive__sk7T2 {
  border: 1px solid #684aff;
  color: #684aff;
  background-color: #fff;
}
.skin12_skin12__\\+oCbv .skin12_header__Pbeb9 .skin12_inputWrapper__Dc2pO .skin12_inputWrapperContainer__C9gdU .skin12_line__VdoRV {
  margin: 4.266667vw 0;
  width: 100%;
  height: 1px;
  background-color: #eaeaea;
}
.skin12_skin12__\\+oCbv .skin12_header__Pbeb9 .skin12_inputWrapper__Dc2pO .skin12_inputWrapperContainer__C9gdU .skin12_moneyRateTips__pw5cE {
  display: flex;
  align-items: center;
}
.skin12_skin12__\\+oCbv .skin12_header__Pbeb9 .skin12_inputWrapper__Dc2pO .skin12_inputWrapperContainer__C9gdU .skin12_moneyRateTips__pw5cE .skin12_moneyRateText1__0\\+2RR {
  margin-right: 2.133333vw;
  border-radius: 1.066667vw;
  padding: 0.8vw 2.133333vw;
  font-size: 3.2vw;
  color: #ffffff;
  background-color: #de9960;
}
.skin12_skin12__\\+oCbv .skin12_header__Pbeb9 .skin12_inputWrapper__Dc2pO .skin12_inputWrapperContainer__C9gdU .skin12_moneyRateTips__pw5cE .skin12_moneyRateText2__k0D3Y {
  color: #262626;
}
.skin12_skin12__\\+oCbv .skin12_checkBox__gG6BU {
  margin: 2.933333vw auto 4.266667vw;
  border-radius: 2.133333vw;
  padding-bottom: 8.533333vw;
  width: 93.866667vw;
  background: #ffffff;
}
.skin12_skin12__\\+oCbv .skin12_checkBox__gG6BU .skin12_title__InbXF {
  border-radius: 1.6vw 1.6vw 0 0;
  width: 100%;
  height: 10.133333vw;
  font-size: 3.2vw;
  font-weight: 400;
  text-align: center;
  color: #eab765;
  background: linear-gradient(1turn, #a18eff, #684aff);
  line-height: 10.133333vw;
}
.skin12_skin12__\\+oCbv .skin12_checkBox__gG6BU h3 {
  padding: 3.2vw 4.266667vw 0;
  font-size: 4.266667vw;
  font-weight: 600;
  color: #333333;
}
.skin12_skin12__\\+oCbv .skin12_checkBox__gG6BU h3 span {
  font-size: 3.2vw;
  font-weight: normal;
  color: #bb6c1d;
}
.skin12_skin12__\\+oCbv .skin12_checkBox__gG6BU .skin12_loanTermList__iWBnW {
  display: flex;
  justify-content: space-between;
  margin-top: 4.266667vw;
  padding: 0 4.266667vw;
  flex-wrap: wrap;
}
.skin12_skin12__\\+oCbv .skin12_checkBox__gG6BU .skin12_loanTermList__iWBnW .skin12_loanTermItem__1fsvm {
  border-radius: 1.333333vw;
  width: 26.933333vw;
  height: 8vw;
  font-weight: 600;
  text-align: center;
  background-color: #f3f4f6;
  box-sizing: border-box;
}
.skin12_skin12__\\+oCbv .skin12_checkBox__gG6BU .skin12_loanTermList__iWBnW .skin12_loanTermItem__1fsvm p {
  font-size: 3.733333vw;
  color: #8c8c8c;
}
.skin12_skin12__\\+oCbv .skin12_checkBox__gG6BU .skin12_loanTermList__iWBnW .skin12_loanTermItem__1fsvm p.skin12_samllText__Auo05 {
  font-size: 3.2vw;
}
.skin12_skin12__\\+oCbv .skin12_checkBox__gG6BU .skin12_loanTermList__iWBnW .skin12_loanTermItem__1fsvm.skin12_active__s1WzI {
  background-color: #684aff;
}
.skin12_skin12__\\+oCbv .skin12_checkBox__gG6BU .skin12_loanTermList__iWBnW .skin12_loanTermItem__1fsvm.skin12_active__s1WzI p {
  font-size: 3.733333vw;
  color: #ffffff;
}
.skin12_skin12__\\+oCbv .skin12_checkBox__gG6BU .skin12_loanTermList__iWBnW .skin12_loanTermItem__1fsvm.skin12_is360Channel__4slsX {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 4.266667vw;
}
.skin12_skin12__\\+oCbv .skin12_checkBox__gG6BU .skin12_bottomBody__QX5lK {
  margin-top: 5.333333vw;
  box-sizing: border-box;
  padding: 0 4.266667vw;
}
.skin12_skin12__\\+oCbv .skin12_checkBox__gG6BU .skin12_bottomBody__QX5lK p {
  display: flex;
  justify-content: center;
  width: 100%;
}
.skin12_skin12__\\+oCbv .skin12_checkBox__gG6BU .skin12_bottomBody__QX5lK p span {
  display: inline-block;
  padding: 0 4.266667vw;
  height: 10.933333vw;
  color: #c16818;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  line-height: 10.933333vw;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.skin12_skin12__\\+oCbv .skin12_checkBox__gG6BU .skin12_bottomBody__QX5lK .skin12_phoneBox__xWc\\+3 {
  display: flex;
  align-items: center;
  margin: 2.4vw auto 0;
  border-radius: 2.133333vw;
  padding-left: 4.266667vw;
  height: 12.266667vw;
  background: #f4f5f7;
}
.skin12_skin12__\\+oCbv .skin12_checkBox__gG6BU .skin12_bottomBody__QX5lK .skin12_phoneBox__xWc\\+3 .skin12_label__89BO5 {
  width: 45.333333vw;
  font-size: 4.266667vw;
  text-align: center;
}
.skin12_skin12__\\+oCbv .skin12_checkBox__gG6BU .skin12_bottomBody__QX5lK .skin12_phoneBox__xWc\\+3 .adm-input-element {
  font-size: 4.266667vw;
  line-height: 8vw;
}
.skin12_skin12__\\+oCbv .skin12_checkBox__gG6BU .skin12_bottomBody__QX5lK .skin12_phoneBox__xWc\\+3 .adm-input-element::placeholder {
  font-size: 4.266667vw;
  line-height: 8vw;
}
.skin12_skin12__\\+oCbv .skin12_checkBox__gG6BU .skin12_bottomBody__QX5lK .skin12_getCms__gJMDl {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 3.2vw;
  border-radius: 1.6vw;
  height: 12.266667vw;
  font-size: 4.266667vw;
  color: #ffffff;
  background-image: linear-gradient(1turn, #a18eff, #684aff);
}
.skin12_skin12__\\+oCbv .skin12_checkBox__gG6BU .skin12_bottomBody__QX5lK .skin12_agreement__FfU4q {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.skin12_skin12__\\+oCbv .skin12_checkBox__gG6BU .skin12_bottomBody__QX5lK .skin12_agreement__FfU4q .skin12_primary__paiDT {
  color: #de9960;
}
.skin12_skin12__\\+oCbv .skin12_checkBox__gG6BU .skin12_bottomBody__QX5lK .skin12_agreement__FfU4q {
  margin-top: 5.333333vw;
  font-size: 3.2vw;
  color: #8c8c8c;
  line-height: 4.8vw;
}
.skin12_skin12__\\+oCbv .skin12_checkBox__gG6BU .skin12_bottomBody__QX5lK .skin12_agreement__FfU4q.skin12_animation__6ROmf {
  position: relative;
  animation: skin12_shake__KsyOP 0.1s;
}
@keyframes skin12_shake__KsyOP {
  0% {
    left: 2.133333vw;
  }
  50% {
    left: -2.133333vw;
  }
  100% {
    left: 0;
  }
}
.skin12_skin12__\\+oCbv .skin12_checkBox__gG6BU .skin12_bottomBody__QX5lK .skin12_agreement__FfU4q .skin12_checked__QCk3y {
  margin-right: 1.6vw;
  border: 1px solid #dddddd;
  width: 4vw;
  height: 4vw;
  border-radius: 35%;
}
.skin12_skin12__\\+oCbv .skin12_checkBox__gG6BU .skin12_bottomBody__QX5lK .skin12_agreement__FfU4q .skin12_checked__QCk3y.skin12_active__s1WzI {
  position: relative;
  border: none;
  background: #ffd28a;
}
.skin12_skin12__\\+oCbv .skin12_checkBox__gG6BU .skin12_bottomBody__QX5lK .skin12_agreement__FfU4q .skin12_checked__QCk3y.skin12_active__s1WzI::before {
  position: absolute;
  top: 1.066667vw;
  left: 0.586667vw;
  width: 2.666667vw;
  height: 1.866667vw;
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: 100%;
}
.skin12_skin12__\\+oCbv .skin12_tipBox__4K6Xf {
  padding-bottom: 13.333333vw;
}
.skin12_skin12__\\+oCbv .skin12_tipBox__4K6Xf .skin12_tip__3Vuv1 {
  font-size: 3.2vw;
  line-height: 5.333333vw;
  text-align: center;
  color: #8C8C8C;
}
.skin12_skin12__\\+oCbv .skin12_dialogOverlay__ep2cR {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  display: none;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
}
.skin12_skin12__\\+oCbv .skin12_dialogOverlay__ep2cR.skin12_showPopup__uaFEX {
  display: block;
}
.skin12_skin12__\\+oCbv .skin12_dialogOverlay__ep2cR .skin12_dialogMain__V9pQf {
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 2.133333vw;
  padding: 5.333333vw 0;
  width: 85.333333vw;
  height: 48vw;
  background-color: #ffffff;
  transform: translate(-50%, -50%);
  box-sizing: border-box;
}
.skin12_skin12__\\+oCbv .skin12_dialogOverlay__ep2cR .skin12_dialogMain__V9pQf .skin12_close__OeUba {
  margin-right: 5.333333vw;
  padding-right: 5.333333vw;
  width: 100%;
  font-size: 5.333333vw;
  text-align: right;
  color: rgb(214, 217, 223);
  box-sizing: border-box;
}
.skin12_skin12__\\+oCbv .skin12_dialogOverlay__ep2cR .skin12_dialogMain__V9pQf .skin12_inputBox__VtveO {
  display: flex;
  align-items: center;
  margin: 2.666667vw auto;
  border: 1px solid #eab765;
  border-radius: 2.133333vw;
  padding-left: 5.333333vw;
  width: 76vw;
  height: 12.8vw;
}
.skin12_skin12__\\+oCbv .skin12_dialogOverlay__ep2cR .skin12_dialogMain__V9pQf .skin12_inputBox__VtveO .skin12_code__PuoOc {
  width: 40vw;
  text-align: center;
  color: #eab765;
}
.skin12_skin12__\\+oCbv .skin12_dialogOverlay__ep2cR .skin12_dialogMain__V9pQf .skin12_inputBox__VtveO .adm-input-element {
  font-size: 4vw;
  line-height: 8vw;
}
.skin12_skin12__\\+oCbv .skin12_dialogOverlay__ep2cR .skin12_dialogMain__V9pQf .skin12_limit__PZOrd {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 4.8vw auto;
  border-radius: 1.6vw;
  width: 75.466667vw;
  height: 11.733333vw;
  font-size: 4.266667vw;
  color: #ffffff;
  background-image: linear-gradient(1turn, #a18eff, #684aff);
}

.adm-auto-center .adm-auto-center-content {
  text-align: center !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/mixin.scss","webpack://./src/pages/register/components/skin12/skin12.module.scss","webpack://./src/styles/var.scss"],"names":[],"mappings":"AA4KA;EACE;IACE,uBAAA;EC3KF;ED8KA;IACE,yBAAA;EC5KF;AACF;AAJA;EACE,YAAA;EACA,yBAAA;EACA,mBAAA;AAMF;AAJE;EACE,yCAAA;EACA,WAAA;EACA,4BAAA;EACA,iCAAA;EACA,0DAAA;AAMJ;AAJI;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;AAMN;AAJM;EACE,wBAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;EACA,yDAAA;AAMR;AAHM;EACE,aAAA;EACA,sBAAA;AAKR;AAHQ;EACE,kBAAA;EACA,aAAA;AAKV;AAFQ;EAEE,aAAA;AAGV;AAAQ;EAEE,aAAA;AACV;AAEQ;EACE,sBAAA;EACA,kBAAA;EACA,kBAAA;AAAV;AAGQ;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,8CAAA;AADV;AAMI;EACE,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,+DAAA;AAJN;AAMM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,mBAAA;AAJR;AAOM;EACE,iBAAA;EACA,+BAAA;AALR;AAOQ;EACE,yBAAA;EACA,qBAAA;EACA,cAAA;AALV;AAQQ;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AANV;AAQU;EACE,sBAAA;EACA,wBAAA;AANZ;AAUY;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;AARd;AAUc;EACE,qBAAA;EACA,gBAAA;EACA,mBAAA;AARhB;AAaU;EACE,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAXZ;AAaY;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAXd;AAgBQ;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;AAdV;AAgBU;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,8BAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,SAAA;EACA,sBAAA;EACA,mBAAA;AAdZ;AAgBY;EACE,oBAAA;AAdd;AAiBY;EACE,yBAAA;EACA,cCjIA;EDkIA,sBAAA;AAfd;AAoBQ;EACE,oBAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;AAlBV;AAqBQ;EACE,aAAA;EACA,mBAAA;AAnBV;AAqBU;EACE,wBAAA;EACA,yBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;AAnBZ;AAsBU;EACE,cAAA;AApBZ;AA2BE;EACE,kCAAA;EACA,yBAAA;EACA,0BAAA;EACA,kBAAA;EACA,mBAAA;AAzBJ;AA2BI;EACE,8BAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,oDC/KmB;EDgLnB,wBAAA;AAzBN;AA4BI;EACE,2BAAA;EACA,qBAAA;EACA,gBAAA;EACA,cAAA;AA1BN;AA4BM;EACE,gBAAA;EACA,mBAAA;EACA,cAAA;AA1BR;AA8BI;EACE,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,qBAAA;EACA,eAAA;AA5BN;AA8BM;EACE,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;AA5BR;AA8BQ;EACE,qBAAA;EACA,cAAA;AA5BV;AA8BU;EACE,gBAAA;AA5BZ;AAgCQ;EACE,yBC7NI;AD+Ld;AAgCU;EACE,qBAAA;EACA,cAAA;AA9BZ;AAkCQ;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;AAhCV;AAqCI;EACE,sBAAA;EACA,sBAAA;EACA,qBAAA;AAnCN;AAqCM;EACE,aAAA;EACA,uBAAA;EACA,WAAA;AAnCR;AAqCQ;EACE,qBAAA;EACA,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,4BAAA;EACA,0BAAA;EACA,wBAAA;EACA,yDAAA;AAnCV;AAuCM;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,yBAAA;EACA,wBAAA;EACA,mBAAA;EACA,mBAAA;AArCR;AAuCQ;EACE,kBAAA;EACA,qBAAA;EACA,kBAAA;AArCV;AAyCU;EACE,qBAAA;EACA,gBAAA;AAvCZ;AAyCY;EACE,qBAAA;EACA,gBAAA;AAvCd;AA6CM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,0DCtSiB;AD2PzB;AA8CM;ED7EJ,aAAA;EAGE,uBAAA;EAIA,mBAAA;ECyEI,eAAA;AA3CR;AA6CQ;EACE,cAAA;AA3CV;AAqCM;EASE,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AA3CR;AA6CQ;EACE,kBAAA;EACA,mCAAA;AA3CV;AA8CQ;EACE;IACE,gBAAA;EA5CV;EA+CQ;IACE,iBAAA;EA7CV;EAgDQ;IACE,OAAA;EA9CV;AACF;AAiDQ;EACE,mBAAA;EACA,yBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;AA/CV;AAiDU;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;AA/CZ;AAiDY;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,yDAAA;EACA,qBAAA;AA/Cd;AAuDE;EACE,2BAAA;AArDJ;AAuDI;EACE,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cCtXY;ADiUlB;AAyDE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;EACA,oCAAA;AAvDJ;AAyDI;EACE,cAAA;AAvDN;AA0DI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,gCAAA;EACA,sBAAA;AAxDN;AA0DM;EACE,wBAAA;EACA,yBAAA;EACA,WAAA;EACA,qBAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;AAxDR;AA2DM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,yBAAA;EACA,wBAAA;EACA,WAAA;EACA,cAAA;AAzDR;AA2DQ;EACE,WAAA;EACA,kBAAA;EACA,cAAA;AAzDV;AA6DU;EACE,cAAA;EACA,gBAAA;AA3DZ;AAgEM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,0DCvbiB;ADyXzB;;AAsEI;EACE,6BAAA;AAnEN","sourcesContent":["@charset \"UTF-8\";\n\n// 圆圈\n@mixin circle($width) {\n  display: inline-block;\n  border-radius: 50%;\n  width: $width;\n  height: $width;\n}\n\n// 省略号样式\n@mixin ellipsis($lineNum: \"\") {\n  overflow: hidden;\n\n  @if $lineNum != \"\" {\n    /* stylelint-disable-next-line */\n    display: -webkit-box;\n    /* stylelint-disable-next-line */\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: $lineNum;\n  } @else {\n    display: inline-block;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n// css箭头\n@mixin arrow($direction, $width, $height, $color) {\n  display: inline-block;\n  width: 0;\n  height: 0;\n\n  @if $direction == \"top\" {\n    border-top: 0;\n    border-right: solid $width transparent;\n    border-bottom: solid $height $color;\n    border-left: solid $width transparent;\n  } @else if $direction == \"bottom\" {\n    border-top: solid $height $color;\n    border-right: solid $width transparent;\n    border-bottom: 0;\n    border-left: solid $width transparent;\n  } @else if $direction == \"left\" {\n    border-top: solid $height transparent;\n    border-right: solid $width $color;\n    border-bottom: solid $height transparent;\n    border-left: 0;\n  } @else if $direction == \"right\" {\n    border-top: solid $height transparent;\n    border-right: 0;\n    border-bottom: solid $height transparent;\n    border-left: solid $width $color;\n  }\n}\n\n// 上下左右居中，为解决被外部数据覆盖的问题，强制使用!important\n@mixin setXYMiddle($width, $height) {\n  position: absolute !important;\n  top: 50% !important;\n  left: 50% !important;\n  margin-top: -$height / 2 !important;\n  margin-left: -$width / 2 !important;\n  width: $width !important;\n  min-width: unset;\n  height: $height !important;\n}\n\n// 上下居中\n@mixin setYMiddle($height) {\n  position: absolute;\n  top: 50%;\n  margin-top: -$height / 2;\n  height: $height;\n}\n\n// 左右居中\n@mixin setXMiddle($width) {\n  position: absolute;\n  left: 50%;\n  margin-left: -$width / 2;\n  width: $width;\n}\n\n// 切换动画\n@mixin transition($type) {\n  transition: .3s $type;\n}\n\n// 按钮公共样式\n@mixin btn-normal($color) {\n  @include transition(background-color);\n\n  border-color: $color;\n  border-radius: 20px;\n  width: 90px;\n  height: 40px;\n  font-size: $font-size-14;\n  text-align: center;\n  color: $color-FFFFFF;\n  background: $color;\n  line-height: 40px;\n  cursor: pointer;\n  user-select: none;\n}\n\n// 失效状态，强制使用同一种颜色\n@mixin disable($type, $color) {\n  cursor: not-allowed !important;\n\n  @if $type == \"color\" {\n    color: $color !important;\n\n    &:hover {\n      color: $color !important;\n    }\n\n    &:active {\n      color: $color !important;\n    }\n  } @else if $type == \"background-color\" {\n    background-color: $color !important;\n\n    &:hover {\n      background-color: $color !important;\n    }\n\n    &:active {\n      background-color: $color !important;\n    }\n  }\n}\n\n// 全局阴影效果\n@mixin shadow {\n  box-shadow: 0 0 10px 2px rgba(#5E5C5C, .25);\n}\n\n// 变色样式\n@mixin action-green($type) {\n  @include transition($type);\n\n  cursor: pointer;\n\n  @if $type == \"color\" {\n    &:hover {\n      color: $color-55DE99 !important;\n    }\n\n    &:active {\n      color: $color-22B76B !important;\n    }\n  } @else if $type == \"background-color\" {\n    &:hover {\n      background-color: $color-55DE99 !important;\n    }\n\n    &:active {\n      background-color: $color-22B76B !important;\n    }\n  }\n}\n\n// 清除浮动\n@mixin clearfix {\n  &::after {\n    content: \"\";\n    display: block;\n    clear: both;\n  }\n}\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n// 旋转\n@mixin animation-rotate() {\n  animation-duration: 1s;\n  animation-name: rotate;\n  animation-iteration-count: infinite;\n  animation-timing-function: cubic-bezier(1, 1, 1, 1);\n}\n\n// 文本n行溢出隐藏显示...\n@mixin ellipsis-basic($n) {\n  /* stylelint-disable-next-line value-no-vendor-prefix */\n  display: -webkit-box;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: $n;\n  -webkit-line: $n;\n  word-break: break-all;\n  word-wrap: break-word;\n}\n\n// 文本不换行\n@mixin no-wrap {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n// 宽高\n@mixin wh($w: 100%, $h: 100%) {\n  width: $w;\n  height: $h;\n}\n\n// 跳转文字 有hover效果\n@mixin link($color: $text-grey-color, $hover-color: $text-grey-color) {\n  position: relative;\n  color: $color;\n  cursor: pointer;\n  user-select: none;\n\n  @content;\n\n  &:hover {\n    color: $hover-color;\n  }\n}\n\n// 跳转文字 带下划线 有hover效果\n@mixin link-underline($color: $text-grey-color, $hover-color: $text-grey-color) {\n  @include link($color, $hover-color) {\n    &:hover {\n      &::after {\n        border-bottom-color: $hover-color;\n      }\n    }\n\n    &::after {\n      position: absolute;\n      bottom: 0;\n      content: \"\";\n      left: 0;\n      border-bottom: 1px solid $color;\n      width: 100%;\n    }\n  }\n}\n\n// flex 布局\n@mixin flex($obj) {\n  display: flex;\n\n  @if map-get($obj, \"justify\") {\n    justify-content: map-get($obj, \"justify\");\n  }\n\n  @if map-get($obj, \"align\") {\n    align-items: map-get($obj, \"align\");\n  }\n}\n\n// flex 水平居中\n@mixin flex-c {\n  @include flex((justify: center));\n}\n\n// flex 垂直居中\n@mixin flex-vc {\n  @include flex((align: center));\n}\n\n// flex 水平两端对齐\n@mixin flex-sb {\n  @include flex((justify: space-between));\n}\n\n// flex 水平垂直居中\n@mixin flex-cc {\n  @include flex((justify: center, align: center));\n}\n\n// flex 水平两端对齐，垂直居中\n@mixin flex-sbc {\n  @include flex((justify: space-between, align: center));\n}","@import \"@/styles/var.scss\";\n@import \"@/styles/mixin.scss\";\n\n.skin12 {\n  height: 100%;\n  background-color: #f5f6f9;\n  line-height: normal;\n\n  .header {\n    padding: 20px 16px 10px;\n    width: 100%;\n    background-repeat: no-repeat;\n    background-size: 100% 220px;\n    background-image:linear-gradient(1turn, #DDDDFA, #7D7DFD);\n\n    .logoBox {\n      display: flex;\n      align-items: center;\n      font-size: 20px;\n      font-weight: 600;\n      line-height: 20px;\n\n      .logo {\n        margin-right: 10px;\n        width: 42px;\n        height: 42px;\n        background-size: 100%;\n        background-image: url(\"~@imgs/register/purple-theme/logo.png\");\n      }\n\n      .logoBoxRight {\n        display: flex;\n        flex-direction: column;\n\n        .logoText {\n          width: 80px;\n          height: 21px;\n        }\n\n        .youqianLogoText {\n          //width: 54px;\n          height: 21px;\n        }\n\n        .youqianLogoText {\n          //width: 60px;\n          height: 21px;\n        }\n\n        .logoText2 {\n          margin-top: 4px;\n          width: 76px;\n          height: 10px;\n        }\n\n        .logoText3 {\n          margin-top: 1px;\n          font-size: 12px;\n          font-weight: 600;\n          color: #ffffff;\n          transform: scale(0.86) translateX(-10px);\n        }\n      }\n    }\n\n    .inputWrapper {\n      margin-top: 25px;\n      border-radius: 8px;\n      width: 343px;\n      background: linear-gradient(180deg, #fbe5d7 0%, #ffffff 27.54%);\n\n      .inputWrapperHead {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 0 29px;\n        width: 100%;\n        height: 50px;\n      }\n\n      .inputWrapperContainer {\n        margin-top: 12px;\n        padding: 24px 12px 16px;\n\n        .inputWrapperContainetTips {\n          margin-bottom: 8px;\n          font-size: 14px;\n          color: #262626;\n        }\n\n        .inputBox {\n          position: relative;\n          display: flex;\n          align-items: center;\n\n          .inputBoxSymbol {\n            font-size: 38px;\n            line-height: 52px;\n          }\n\n          :global {\n            .adm-input-element {\n              font-size: 33px;\n              font-weight: 600;\n              line-height: 30px;\n\n              &::placeholder {\n                font-size: 22px;\n                line-height: 30px;\n                font-weight: normal;\n              }\n            }\n          }\n\n          .text {\n            position: absolute;\n            right: 0;\n            bottom: 14px;\n            display: flex;\n            align-items: center;\n            font-size: 12px;\n            color: #de9960;\n\n            .clear {\n              padding-left: 9px;\n              font-size: 16px;\n              color: #8c8c8c;\n            }\n          }\n        }\n\n        .moneyOptions {\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n          margin-top: 10px;\n\n          .moneyItem {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            border-radius: 6px;\n            padding: 4px 8px;\n            height: 32px;\n            font-size: 14px;\n            font-weight: 600;\n            color: #8c8c8c;\n            background-color: #f3f4f6;\n            flex: 1;\n            box-sizing: border-box;\n            line-height: normal;\n\n            &:nth-child(2n + 2) {\n              margin: 0 8px;\n            }\n\n            &.moneyItemActive {\n              border: 1px solid $text-skin12;\n              color: $text-skin12;\n              background-color: #fff;\n            }\n          }\n        }\n\n        .line {\n          margin: 16px 0;\n          width: 100%;\n          height: 1px;\n          background-color: #eaeaea;\n        }\n\n        .moneyRateTips {\n          display: flex;\n          align-items: center;\n\n          .moneyRateText1 {\n            margin-right: 8px;\n            border-radius: 4px;\n            padding: 3px 8px;\n            font-size: 12px;\n            color: #ffffff;\n            background-color: #de9960;\n          }\n\n          .moneyRateText2 {\n            color: #262626;\n          }\n        }\n      }\n    }\n  }\n\n  .checkBox {\n    margin: 11px auto 16px;\n    border-radius: 8px;\n    padding-bottom: 32px;\n    width: 352px;\n    background: #ffffff;\n\n    .title {\n      border-radius: 6px 6px 0 0;\n      width: 100%;\n      height: 38px;\n      font-size: 12px;\n      font-weight: 400;\n      text-align: center;\n      color: #eab765;\n      background: $linear-gradient-skin12;\n      line-height: 38px;\n    }\n\n    h3 {\n      padding: 12px 16px 0;\n      font-size: 16px;\n      font-weight: 600;\n      color: #333333;\n\n      span {\n        font-size: 12px;\n        font-weight: normal;\n        color: #bb6c1d;\n      }\n    }\n\n    .loanTermList {\n      display: flex;\n      justify-content: space-between;\n      margin-top: 16px;\n      padding: 0 16px;\n      flex-wrap: wrap;\n\n      .loanTermItem {\n        border-radius: 5px;\n        width: 101px;\n        height: 30px;\n        font-weight: 600;\n        text-align: center;\n        background-color: #f3f4f6;\n        box-sizing: border-box;\n\n        p {\n          font-size: 14px;\n          color: #8c8c8c;\n\n          &.samllText {\n            font-size: 12px;\n          }\n        }\n\n        &.active {\n          background-color: $text-skin12;\n\n          p {\n            font-size: 14px;\n            color: #ffffff;\n          }\n        }\n\n        &.is360Channel {\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          font-size: 16px;\n        }\n      }\n    }\n\n    .bottomBody {\n      margin-top: 20px;\n      box-sizing: border-box;\n      padding: 0 16px;\n\n      p {\n        display: flex;\n        justify-content: center;\n        width: 100%;\n\n        span {\n          display: inline-block;\n          padding: 0 16px;\n          height: 41px;\n          color: #c16818;\n          background-repeat: no-repeat;\n          background-size: 100% 100%;\n          line-height: 41px;\n          background-image: url(\"~@imgs/register/new-theme/bottom-body-bg.png\");\n        }\n      }\n\n      .phoneBox {\n        display: flex;\n        align-items: center;\n        margin: 9px auto 0;\n        border-radius: 8px;\n        padding-left: 16px;\n        height: 46px;\n        background: #f4f5f7;\n\n        .label {\n          width: 170px;\n          font-size: 16px;\n          text-align: center;\n        }\n\n        :global {\n          .adm-input-element {\n            font-size: 16px;\n            line-height: 30px;\n\n            &::placeholder {\n              font-size: 16px;\n              line-height: 30px;\n            }\n          }\n        }\n      }\n\n      .getCms {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        margin-top: 12px;\n        border-radius: 6px;\n        height: 46px;\n        font-size: 16px;\n        color: #ffffff;\n        background-image: $linear-gradient-skin12;\n      }\n\n      .agreement {\n        @include flex-cc;\n\n        flex-wrap: wrap;\n\n        .primary {\n          color: #de9960;\n        }\n\n        margin-top: 20px;\n        font-size: 12px;\n        color: #8c8c8c;\n        line-height: 18px;\n\n        &.animation {\n          position: relative;\n          animation: shake 0.1s;\n        }\n\n        @keyframes shake {\n          0% {\n            left: 8px;\n          }\n\n          50% {\n            left: -8px;\n          }\n\n          100% {\n            left: 0;\n          }\n        }\n\n        .checked {\n          margin-right: 6px;\n          border: 1px solid #dddddd;\n          width: 15px;\n          height: 15px;\n          border-radius: 35%;\n\n          &.active {\n            position: relative;\n            border: none;\n            background: #ffd28a;\n\n            &::before {\n              position: absolute;\n              top: 4px;\n              left: 2.2px;\n              width: 10px;\n              height: 7px;\n              content: \"\";\n              background-image: url(\"~@imgs/activity/check.png\");\n              background-size: 100%;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .tipBox {\n    padding-bottom: 50px;\n\n    .tip {\n      font-size: 12px;\n      line-height: 20px;\n      text-align: center;\n      color: $text-gray-color;\n    }\n  }\n\n  .dialogOverlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 100;\n    display: none;\n    width: 100%;\n    height: 100vh;\n    background-color: rgb(0 0 0 / 70%);\n\n    &.showPopup {\n      display: block;\n    }\n\n    .dialogMain {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      border-radius: 8px;\n      padding: 20px 0;\n      width: 320px;\n      height: 180px;\n      background-color: #ffffff;\n      transform: translate(-50%, -50%);\n      box-sizing: border-box;\n\n      .close {\n        margin-right: 20px;\n        padding-right: 20px;\n        width: 100%;\n        font-size: 20px;\n        text-align: right;\n        color: rgb(214 217 223);\n        box-sizing: border-box;\n      }\n\n      .inputBox {\n        display: flex;\n        align-items: center;\n        margin: 10px auto;\n        border: 1px solid #eab765;\n        border-radius: 8px;\n        padding-left: 20px;\n        width: 285px;\n        height: 48px;\n\n        .code {\n          width: 150px;\n          text-align: center;\n          color: #eab765;\n        }\n\n        :global {\n          .adm-input-element {\n            font-size: 15px;\n            line-height: 30px;\n          }\n        }\n      }\n\n      .limit {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        margin: 18px auto;\n        border-radius: 6px;\n        width: 283px;\n        height: 44px;\n        font-size: 16px;\n        color: #ffffff;\n        background-image: $linear-gradient-skin12;\n      }\n    }\n  }\n}\n\n:global {\n  .adm-auto-center {\n    .adm-auto-center-content {\n      text-align: center !important;\n    }\n  }\n}\n","// 公共颜色\n$color-primary: #FF4D4F;\n\n// 主字色\n$color-black: #262626;\n$color-white: #FFFFFF;\n\n// 浅红\n$light-red: #FFF1F0;\n\n// 浅红背景\n$light-red-bg: #FFF3F4;\n\n// 背景色\n$background-color: #F6F6F6;\n\n// 线条颜色\n$line-color: #F0F0F0;\n\n// 边框颜色\n$border-color: #D9D9D9;\n\n// 文字灰色颜色\n$text-gray-color: #8C8C8C;\n\n// 渐变色\n$linear-gradient: linear-gradient(108.61deg, #FF606E 3.46%, #FF192C 97.1%);\n\n// skin12字体颜色\n$text-skin12: #684aff;\n\n// skin12渐变色\n$linear-gradient-skin12: linear-gradient(1turn, #a18eff, #684aff);\n\n// 占位符颜色\n$placeholder-color: #BFBFBF;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skin12": `skin12_skin12__+oCbv`,
	"header": `skin12_header__Pbeb9`,
	"logoBox": `skin12_logoBox__CGCWS`,
	"logo": `skin12_logo__F142n`,
	"logoBoxRight": `skin12_logoBoxRight__N21O0`,
	"logoText": `skin12_logoText__XfZyb`,
	"youqianLogoText": `skin12_youqianLogoText__P4Av-`,
	"logoText2": `skin12_logoText2__pZmv1`,
	"logoText3": `skin12_logoText3__wrliU`,
	"inputWrapper": `skin12_inputWrapper__Dc2pO`,
	"inputWrapperHead": `skin12_inputWrapperHead__gXHjk`,
	"inputWrapperContainer": `skin12_inputWrapperContainer__C9gdU`,
	"inputWrapperContainetTips": `skin12_inputWrapperContainetTips__+7UHi`,
	"inputBox": `skin12_inputBox__VtveO`,
	"inputBoxSymbol": `skin12_inputBoxSymbol__uSjT1`,
	"text": `skin12_text__bkLpf`,
	"clear": `skin12_clear__0NJ-r`,
	"moneyOptions": `skin12_moneyOptions__IvfZm`,
	"moneyItem": `skin12_moneyItem__ZGgVb`,
	"moneyItemActive": `skin12_moneyItemActive__sk7T2`,
	"line": `skin12_line__VdoRV`,
	"moneyRateTips": `skin12_moneyRateTips__pw5cE`,
	"moneyRateText1": `skin12_moneyRateText1__0+2RR`,
	"moneyRateText2": `skin12_moneyRateText2__k0D3Y`,
	"checkBox": `skin12_checkBox__gG6BU`,
	"title": `skin12_title__InbXF`,
	"loanTermList": `skin12_loanTermList__iWBnW`,
	"loanTermItem": `skin12_loanTermItem__1fsvm`,
	"samllText": `skin12_samllText__Auo05`,
	"active": `skin12_active__s1WzI`,
	"is360Channel": `skin12_is360Channel__4slsX`,
	"bottomBody": `skin12_bottomBody__QX5lK`,
	"phoneBox": `skin12_phoneBox__xWc+3`,
	"label": `skin12_label__89BO5`,
	"getCms": `skin12_getCms__gJMDl`,
	"agreement": `skin12_agreement__FfU4q`,
	"primary": `skin12_primary__paiDT`,
	"animation": `skin12_animation__6ROmf`,
	"shake": `skin12_shake__KsyOP`,
	"checked": `skin12_checked__QCk3y`,
	"tipBox": `skin12_tipBox__4K6Xf`,
	"tip": `skin12_tip__3Vuv1`,
	"dialogOverlay": `skin12_dialogOverlay__ep2cR`,
	"showPopup": `skin12_showPopup__uaFEX`,
	"dialogMain": `skin12_dialogMain__V9pQf`,
	"close": `skin12_close__OeUba`,
	"code": `skin12_code__PuoOc`,
	"limit": `skin12_limit__PZOrd`,
	"rotate": `skin12_rotate__hHuvF`
};
export default ___CSS_LOADER_EXPORT___;
